import { ValidationModel, ValidationType } from "@/services/validation/types";

export const settingsValidators = {
    name: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 3 }
        ]
    } as ValidationModel,
    transitionTime: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 0 },
            { type: ValidationType.Max, value: 100000 }
        ]
    } as ValidationModel,
    returnToFirstPostTime: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 5 },
            { type: ValidationType.Max, value: 100000 }
        ]
    } as ValidationModel,
    width: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 1 },
            { type: ValidationType.Max, value: 100000 }

        ]
    } as ValidationModel,
    height: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 1 },
            { type: ValidationType.Max, value: 100000 }
        ]
    } as ValidationModel,
    defaultShowTime: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 1 },
            { type: ValidationType.Max, value: 100000 }
        ]
    } as ValidationModel
};

export const copyValidators = {
    name: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 3 }
        ]
    } as ValidationModel,
    width: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 1 },
            { type: ValidationType.Max, value: 100000 }

        ]
    } as ValidationModel,
    height: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 1 },
            { type: ValidationType.Max, value: 100000 }
        ]
    } as ValidationModel
};
